// ============================================================================
// ZONE ENDPOINTS
// ============================================================================
// BASE_PATH MUST match the backend controller's [controller] route token.
// ZoneController → api/v1/Zone → BASE_PATH = '/Zone' (singular, matching the C# class name).

import { buildEndpoint, buildEndpointWithParams } from './base.endpoints';
import type { ID } from '../types';

export const ZONE_BASE_PATH = '/Zone';

export const zoneEndpoints = {
  /** GET /api/v1/Zone — paginated list */
  list: () => buildEndpoint(ZONE_BASE_PATH),

  /** GET /api/v1/Zone/:id */
  getById: (id: ID) =>
    buildEndpointWithParams(`${ZONE_BASE_PATH}/:id`, { id }),

  /** GET /api/v1/Zone/code/:code */
  getByCode: (code: string) =>
    buildEndpointWithParams(`${ZONE_BASE_PATH}/code/:code`, { code }),

  /** POST /api/v1/Zone */
  create: () => buildEndpoint(ZONE_BASE_PATH),

  /** PUT /api/v1/Zone/:id */
  update: (id: ID) =>
    buildEndpointWithParams(`${ZONE_BASE_PATH}/:id`, { id }),

  /** DELETE /api/v1/Zone/:id — soft delete */
  delete: (id: ID) =>
    buildEndpointWithParams(`${ZONE_BASE_PATH}/:id`, { id }),

  /** GET /api/v1/Zone/validate/code/:code */
  validateCode: (code: string) =>
    buildEndpointWithParams(`${ZONE_BASE_PATH}/validate/code/:code`, { code }),
} as const;

export default zoneEndpoints;
